'use strict';

const timeFilter = require('../../../../../utils/timestamp-util').timestampToDateFilter;
const parseSingleChannel = require('../uart/regular-report-parser').parseSingleChannel;

const UC_TYPE = [
    "DI (UC3X14)",
    "AI (UC3X22)",
    "UART (UC3X52)",
];

function parse(reader) {
    reader.readUInt8("version");
    reader.readUInt32LE("data.timestamp", timeFilter);
    let type = reader.readUInt8("data.unit_type", value => UC_TYPE[value]);
    handler[type](reader);
}

function parse_di(reader) {
    reader.readUInt8("data.mobile_signal");
    reader.readUInt8("data.din");
    reader.readUInt8("data.dout");
}

function parse_ai(reader) {
    let i = reader.readUInt8("data.index", value => value + 1) + 1;
    let count = reader.readUInt8(`data.ain_${i}.count`);
    reader.readUInt32LE(`data.ain_${i}.time_step`);
    reader.readFloatLEInBatch(count, 0, `data.ain_${i}.values`);
}

function parse_uart(reader) {
    let i = reader.readUInt8("data.index", value => value + 1) + 1;
    parseSingleChannel(reader, i);
}

const handler = [
    parse_di,
    parse_ai,
    parse_uart,
];

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_3/common/intelligence-report-parser.js